<div class="modal-header bg-dark text-white">
  <h4 class="modal-title">Edit Award</h4>
  <div class="ms-auto" data-bs-theme="dark">
    <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="cancel()"></button>
  </div>
</div>

<div class="modal-body">
  <!-- Location Information Card -->
  <div class="card mb-3">
    <div class="card-header bg-light">
      <h6 class="card-title mb-0">
        <ng-icon name="lucideMapPin" class="me-2"></ng-icon>
        Location Information
      </h6>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-3 mb-2">
          <div class="text-muted small">Location</div>
          <div class="fw-bold">{{offer?.location_name}}</div>
        </div>
        <div class="col-md-3 mb-2" *ngIf="!tender?.company?.settings?.isHiddenField('location_company')">
          <div class="text-muted small">Company Info</div>
          <div class="fw-bold">
            <span *ngIf="offer?.company_child && offer?.company_child?.name">
              {{ offer.company_child.alias || offer.company_child.name }}
            </span>
            <span *ngIf="!offer?.company_child || !offer?.company_child?.name">
              {{ offer?.company_info || 'N/A' }}
            </span>
          </div>
        </div>
        <div class="col-md-3 mb-2" *ngIf="!tender?.company?.settings?.isHiddenField('location_fuel_type')">
          <div class="text-muted small">Fuel Type</div>
          <div class="fw-bold">{{offer?.fuel_type?.name || offer?.fuel_type || 'N/A'}}</div>
        </div>
        <div class="col-md-3 mb-2" *ngIf="!tender?.company?.settings?.isHiddenField('location_flight_type')">
          <div class="text-muted small">Flight Type</div>
          <div class="fw-bold">{{offer?.flight_type?.name || offer?.flight_type || 'N/A'}}</div>
        </div>
        <div class="col-md-3 mb-2" *ngIf="!tender?.company?.settings?.isHiddenField('location_delivery_point')">
          <div class="text-muted small">Preferred Delivery Point</div>
          <div class="fw-bold">{{offer?.delivery_point || 'N/A'}}</div>
        </div>
        <div class="col-md-3 mb-2">
          <div class="text-muted small">Total Volume</div>
          <div class="fw-bold">{{$safeNavigationMigration(offer?.volume) | number:'1.0-0'}} {{offer?.units?.code}}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Current Award Information Card -->
  <div class="card mb-3">
    <div class="card-header bg-light">
      <h6 class="card-title mb-0">
        <ng-icon name="lucideBuilding2" class="me-2"></ng-icon>
        Current Award Information
      </h6>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-3 mb-2">
          <div class="text-muted small">Supplier</div>
          <div class="fw-bold">{{getSupplierName() || 'N/A'}}<span *ngIf="supplierGroup?.supplier?.supplier_alias"> ({{supplierGroup.supplier.supplier_alias}})</span></div>
        </div>
        <div class="col-md-3 mb-2">
          <div class="text-muted small">Current Awarded Contract Volume</div>
          <div class="fw-bold">{{$safeNavigationMigration(offer?.awarded_volume) | number:'1.0-0'}} {{offer?.units?.code}}</div>
        </div>
        <div class="col-md-3 mb-2">
          <div class="text-muted small">Current Award Percentage</div>
          <div class="fw-bold">{{offer?.awarded_percent}}%</div>
        </div>
        <div class="col-md-3 mb-2">
          <div class="text-muted small">Current Contract Type</div>
          <div class="fw-bold">{{offer?.contract_type}}</div>
        </div>
        <div class="col-md-3 mb-2">
          <div class="text-muted small">Contract Start</div>
          <div class="fw-bold">{{getContractStartDate(offer) | date:'dd/MM/yyyy':'UTC'}}</div>
        </div>
        <div class="col-md-3 mb-2">
          <div class="text-muted small">Contract End</div>
          <div class="fw-bold">{{getContractEndDate(offer) | date:'dd/MM/yyyy':'UTC'}}</div>
        </div>
      </div>
    </div>
  </div>

  <form [formGroup]="form" novalidate>
    <div class="row">
      <div class="col-md-6">
        <label class="form-label">Contract Type</label>
        <select class="form-select mb-3" formControlName="award_self_supply">
          <option value="">Fuel & Logistics</option>
          <option value="FUEL_ONLY">Fuel only</option>
          <option value="LOGISTICS">Logistics</option>
        </select>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <label class="form-label">Award Percentage of Total Volume</label>
        <div class="input-group mb-3">
          <input type="text" class="form-control" formControlName="percent_awarded"
            [class.is-invalid]="form.controls['percent_awarded'].invalid && form.controls['percent_awarded'].touched"
            placeholder="35">
          <span class="input-group-text">%</span>
          <div class="invalid-feedback"
            *ngIf="form.controls['percent_awarded'].invalid && form.controls['percent_awarded'].touched">
            <span *ngIf="form.controls['percent_awarded'].errors">Invalid percentage value entered.</span>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <label class="form-label">Award Contract Volume</label>
        <div class="input-group mb-3">
          <input type="text" class="form-control" formControlName="volume"
            [class.is-invalid]="form.controls['volume'].invalid && form.controls['volume'].touched"
            placeholder="33,180,640"
            (blur)="onVolumeBlur()">
          <span class="input-group-text">{{offer?.units?.code}}</span>
          <div class="invalid-feedback"
            *ngIf="form.controls['volume'].invalid && form.controls['volume'].touched">
            <span *ngIf="form.controls['volume'].errors">Invalid volume value entered.</span>
          </div>
        </div>
      </div>
    </div>

    <div class="mb-3">
      <label class="form-label">Contract Terms</label>
      <div class="row">
        <div class="col-md-6">
          <div class="input-group mb-2">
            <input (click)="startDatePicker.toggle()"
              [class.is-invalid]="form.controls['date_contract_start'].invalid && form.controls['date_contract_start'].touched"
              class="form-control datepicker" formControlName="date_contract_start" ngbDatepicker
              #startDatePicker="ngbDatepicker" placeholder="2026-11-01">
            <span class="input-group-text">Start Date</span>
            <div class="invalid-feedback"
              *ngIf="form.controls['date_contract_start'].invalid && form.controls['date_contract_start'].touched">
              <span *ngIf="form.controls['date_contract_start'].errors">Invalid</span>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="input-group">
            <input (click)="endDatePicker.toggle()"
              [class.is-invalid]="form.controls['date_contract_end'].invalid && form.controls['date_contract_end'].touched"
              class="form-control datepicker" formControlName="date_contract_end" ngbDatepicker
              #endDatePicker="ngbDatepicker" placeholder="2027-10-31">
            <span class="input-group-text">End Date</span>
            <div class="invalid-feedback"
              *ngIf="form.controls['date_contract_end'].invalid && form.controls['date_contract_end'].touched">
              <span *ngIf="form.controls['date_contract_end'].errors">Invalid</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-3">
      <label class="form-label" for="awardComment">
        Award Comment
        <span class="badge bg-warning-subtle text-dark border border-warning-subtle ms-1 fw-normal">
          Visible to the supplier
        </span>
      </label>
      <textarea id="awardComment" class="form-control" formControlName="award_comment" rows="3"
        [maxlength]="awardCommentMaxLength"
        placeholder="e.g. Volume ramps up from Q2 &mdash; please countersign by Friday."></textarea>
      <div class="d-flex justify-content-between small text-muted mt-1">
        <span>
          {{ getSupplierName() }} will read this on their Tender Results page and in the award
          notification email, once the award is confirmed.
        </span>
        <span class="text-nowrap ms-2">
          {{ (form.value.award_comment || '').length }}/{{ awardCommentMaxLength }}
        </span>
      </div>
    </div>
  </form>

  <div class="mb-3" *ngIf="form.controls['percent_awarded'].value > 0">
    <div class="card bg-light">
      <div class="card-body py-2">
        <div class="row">
          <div class="col-6">
            <div class="text-muted small">Remaining Volume</div>
            <div class="fw-bold">
              {{ getRemainingVolume() | number:'1.0-0' }} {{ offer?.units?.code }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <a class="btn btn-sm bg-warning-subtle small text-dark mb-3 w-100"
    href="https://docs.jetfueltenders.com/airline/how-to-award-bids/" target="_blank">
    <span class="me-1">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        class="lucide lucide-badge-info">
        <path
          d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z" />
        <line x1="12" x2="12" y1="16" y2="12" />
        <line x1="12" x2="12.01" y1="8" y2="8" />
      </svg>
    </span>
    <span class="fw-bold">How to:</span>
    <span class="fw-normal ms-1">Award Bids at Location</span>
  </a> -->
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-primary text-white" [disabled]="form.invalid || loading" (click)="save()">
    <span *ngIf="loading" class="spinner-border spinner-border-sm me-2" role="status"></span>
    Save Changes
  </button>
  <button type="button" class="btn btn-light" (click)="cancel()">
    Cancel
  </button>
</div>
